import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private Server: string = '';
  private FabricApiUrl: string = '';
  private AppKey: string = '';
  private Console: boolean = false;
  private langs = [];
  private langDefault: number = 1;
  private locale: string = 'en-US';
  private timezone: string = '+0000';
  private Timer: boolean = false;
  private PageSize: number;
  private LogoutUrl: string = '';
  private isLogoutExternal: boolean = false;
  private sessionStorageEnabled: boolean = false;
  private channel: string = '';
  private chaincode: string = '';
  private scanModule: string = '';
  private samlUrl: string = '';
  private ssoUrl: string = '';
  private isSsoEnabled: boolean = false;
  private notificationFormMaxFileSize: number;

  constructor(private _http: HttpClient,private translateService: TranslateService) {}

  public load() {
    return new Promise((resolve, reject) => {
      this._http
        .get('config.json') // path of your config.json file
        .subscribe({
          next: (data: any) => {
            this.Server = data.server;
            this.FabricApiUrl = data.fabricApiUrl;
            this.AppKey = data.appkey;
            this.Console = data.console;
            this.langs = data.langs;
            this.langDefault = data.langDefault;
            this.locale = data.locale != '' ? data.locale : this.locale;
            this.timezone = data.timezone != '' ? data.timezone : this.timezone;
            this.Timer = data.timer;
            this.PageSize = data.pageSize;
            this.LogoutUrl = data.logoutUrl;
            this.isLogoutExternal = data.isLogoutExternal;
            this.sessionStorageEnabled = data.sessionStorageEnabled;
            this.channel = data.channel;
            this.chaincode = data.chaincode;
            this.scanModule = data.scanModule;
            this.samlUrl = data.samlUrl;
            this.ssoUrl = data.ssoUrl;
            this.isSsoEnabled = data.isSsoEnabled;
            this.translateService.addLangs( data.langs.map(a=>a.text));
            this.translateService.setDefaultLang(this.getLangTextByLangId(data.langDefault));
            resolve(true);
          },
          error: (err) => console.log(err),
        });
      /*
            //agapame piraeus
            //this.Server =  "http://192.168.10.34:8282/tesla/"; //tesla1
            //this.Server =  "https://tesla.piraeus-factoring.gr:8444/tesla/"; //tesla2
            //this.Server =  "http://10.200.1.30:8082/tesla/"; // new uat
            this.Server =  "http://10.200.1.30:8092/tesla/";//stage
            this.AppKey = "bnt90abtn90";
            this.Console =  false;
            this.langs = [{"text":"el","id":1},{"text":"en","id":2}];
            this.langDefault = 1;
            this.locale = "el-GR";
            this.Timer = true;
            this.PageSize = 20;
            this.isLogoutExternal = true;
            this.LogoutUrl = "http://www.piraeus-factoring.gr/";
            this.sessionStorageEnabled = true;
            resolve(true);
            */
    });
  }

  public getServer() {
    return this.Server;
  }

  public getFabricApiUrl() {
    return this.FabricApiUrl;
  }

  public getAppKey() {
    return this.AppKey;
  }

  public getConsole() {
    return this.Console;
  }

  public getLangDefault() {
    return this.langDefault;
  }

  public getNotificationFormMaxSizeFile(){
    return this.notificationFormMaxFileSize;
  }

  public getLocale(): string {
    return this.locale;
  }

  public getTimezone(): string {
    return this.timezone;
  }

  public getLangs() {
    return this.langs;
  }

  public getSsoUrl() {
    return this.ssoUrl;
  }
  public getIsSsoEnabled() {
    return this.isSsoEnabled;
  }

  public getSamlUrl() {
    return this.samlUrl;
  }

  public getCurrentLocaleStr(): string {
    let lang = 'en';
    let langId = localStorage.getItem('langId');

    this.getLangs().forEach((element) => {
      if (element['id'] == langId) {
        lang = element['text'];
      }
    });

    return lang;
  }

  public getTimer() {
    return this.Timer;
  }

  public getPageSize() {
    return this.PageSize;
  }

  public getLogoutUrl() {
    return this.LogoutUrl;
  }

  public getIsLogoutExternal() {
    return this.isLogoutExternal;
  }

  public getIsSessionStorage() {
    return this.sessionStorageEnabled;
  }

  public getChannel() {
    return this.channel;
  }

  public getChaincode() {
    return this.chaincode;
  }

  public getScanModule() {
    return this.scanModule;
  }

  public isLang1Enabled() : boolean {
    return !!this.getLangs().find( item => item.id == 1);
  }

  public isLang1RightToLeft() : boolean {
    return this.isLang1Enabled() && this.langs.find( item => item.id == 1).text == 'ar';

  }

  public isLang2Enabled() : boolean {
    return !!this.getLangs().find( item => item.id == 2);
  }

  public getLangTextByLangId(langId){
    return this.getLangs().find(a=>a.id==langId).text;
  }
}
